/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/horse_exam_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./horse_exam_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient =
  function HorseExamServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient =
  function HorseExamServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExam>}
 */
const methodDescriptor_HorseExamService_GetHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExam,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExam.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExam)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExam>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.getHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_GetHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExam>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.getHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_GetHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamsResponse>}
 */
const methodDescriptor_HorseExamService_ListHorseExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExams",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseExamsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseExamsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.listHorseExams =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExams",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_ListHorseExams,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseExamsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.listHorseExams =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExams",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_ListHorseExams
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExam>}
 */
const methodDescriptor_HorseExamService_CreateHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CreateHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExam,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExam.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExam)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExam>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.createHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CreateHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CreateHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExam>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.createHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CreateHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CreateHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExam>}
 */
const methodDescriptor_HorseExamService_EditHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/EditHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExam,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExam.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExam)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExam>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.editHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/EditHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_EditHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExam>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.editHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/EditHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_EditHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseExamService_DeleteHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/DeleteHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.deleteHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/DeleteHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_DeleteHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.deleteHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/DeleteHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_DeleteHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CancelHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseExamService_CancelHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CancelHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CancelHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CancelHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.cancelHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CancelHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CancelHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.cancelHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CancelHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CancelHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CompleteHorseExamRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExam>}
 */
const methodDescriptor_HorseExamService_CompleteHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CompleteHorseExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CompleteHorseExamRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExam,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CompleteHorseExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExam.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExam)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExam>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.completeHorseExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CompleteHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CompleteHorseExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteHorseExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExam>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.completeHorseExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CompleteHorseExam",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_CompleteHorseExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse>}
 */
const methodDescriptor_HorseExamService_PullHorseExamConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamConditions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamConditionsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamConditionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamConditionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.pullHorseExamConditions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamConditions",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_PullHorseExamConditions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.pullHorseExamConditions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamConditions",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_PullHorseExamConditions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetHorseExamCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExamComment>}
 */
const methodDescriptor_HorseExamService_GetHorseExamComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExamComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetHorseExamCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExamComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExamComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExamComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExamComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.getHorseExamComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExamComment",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_GetHorseExamComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseExamCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExamComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.getHorseExamComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExamComment",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_GetHorseExamComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse>}
 */
const methodDescriptor_HorseExamService_ListHorseExamComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExamComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.listHorseExamComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExamComment",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_ListHorseExamComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.listHorseExamComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExamComment",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_ListHorseExamComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorseExamReportRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorseExamReportResponse>}
 */
const methodDescriptor_HorseExamService_PullHorseExamReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamReport",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamReportRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamReportResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamReportRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorseExamReportResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorseExamReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorseExamReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamServiceClient.prototype.pullHorseExamReport =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamReport",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_PullHorseExamReport,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseExamReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorseExamReportResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamServicePromiseClient.prototype.pullHorseExamReport =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamReport",
      request,
      metadata || {},
      methodDescriptor_HorseExamService_PullHorseExamReport
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
